module.exports = __webpack_public_path__ + "static/towa-background-fc3a84c99c31e387f9487b5a086f6cb1.png";